/* eslint-disable no-use-before-define */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FinancialProductOption } from '../../../resources/base/models/financialProduct';
import { VehicleType } from '../../../resources/base/models/vehicleTypes';

const initialState = {
  data: {
    apiError: {
      hasError: false,
      errorData: {} as any,
      extended: false,
    },
  },
  infoModalText: '',
  selectedFinancialProductData: undefined as FinancialProductOption | undefined,
  selectedVehicleType: undefined as VehicleType | undefined,
  isHybridJourney: false,
  isCarUsed: false,
};

type CustomState = typeof initialState;

export const customSlice = createSlice({
  name: 'custom',
  initialState,
  selectors: {
    selectIsHybridJourney: (state: CustomState) => {
      return state.isHybridJourney;
    },
    selectVehicleType: (state: CustomState) => {
      return state.selectedVehicleType;
    },
  },
  reducers: {
    setApiError(state, { payload }: PayloadAction<CustomState['data']['apiError']>) {
      state.data.apiError = payload;
    },
    clearApiError(state) {
      state.data.apiError = initialState.data.apiError;
    },
    setInfoModalText(state, { payload }: PayloadAction<string>) {
      state.infoModalText = payload;
    },
    setSelectedFinancialProductData(state, { payload }: PayloadAction<FinancialProductOption>) {
      state.selectedFinancialProductData = payload;
    },
    setIsHybridJourney(state, { payload }: PayloadAction<boolean>) {
      state.isHybridJourney = payload;
    },
    setIsCarUsed(state, { payload }: PayloadAction<boolean>) {
      state.isCarUsed = payload;
    },
    resetCustom() {
      return initialState;
    },
    setSelectedVehicleType(state, { payload }: PayloadAction<VehicleType | undefined>) {
      state.selectedVehicleType = payload;
    },
  },
});

export const customSelectors = customSlice.selectors;
export const {
  setApiError,
  setInfoModalText,
  setIsCarUsed,
  setIsHybridJourney,
  setSelectedFinancialProductData,
  resetCustom,
  clearApiError,
  setSelectedVehicleType,
} = customSlice.actions;
export const customReducer = customSlice.reducer;
